<template>
  <div class="container">
    <delivery-address ref="deliveryAddress" header-title="Delivery" :edit-model="editModel" />

    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="Phone Number">Phone Number</label>
        <input
          v-validate="'required|numeric'"
          id="Phone Number"
          v-model="editModel.Phone"
          name="Phone Number"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Phone Number") }}</div>
      </div>
    </div>
  </div>
</template> 

<script>
import shared from "../../sharedscripts/user/DeliveryAddress.js";
import DeliveryAddress from "./../shop/Checkout/partials/DeliveryAddress";
export default {
  components: {
    DeliveryAddress
  },
  props: {
    editModel: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...shared.computed
  },
  methods: {
    ...shared.methods
  }
};
</script>
